export const MYCASES = 'mycases';
export const MYCASES_WIDGET = 'mycases_widget';
export const ALLCASES = 'allcases';
export const CASES_HISTORY = 'cases_history';
export const WAITINGROOM = 'waitingroom';
export const ACTIVITIES = 'activities';
export const ACTIVITIES_WIDGET = 'activities_widget';
export const NOTIFICATIONS = 'notifications';
export const NOTIFICATIONS_WIDGET = 'notifications_widget';
export const MEETING_SUMMARY_FILES = 'meeting_summary_files';
export const MEETING_SUMMARY_INVITEES = 'meeting_summary_invitees';
export const ANALYTIC_TICKETS_LOGS = 'analytic_tickets_logs';
export const TICKETS_REFERRALS = 'tickets_referrals';
export const MANAGEMENT_USERS = 'management_users';
export const CLIENTS_ORGANIZATION = 'clients_organization';
export const SURVEYS = 'surveys';
export const MANAGEMENT_ORGANIZATIONS = 'management_organizations';
export const USER_TICKETS = 'user_tickets';
export const ACTIVITY_ATTENDEES_TICKETS = 'activity_attendees_tickets';
export const USER_INVITATIONS = 'user_invitations';
export const SCHEDULERS = 'schedulers';
export const CHAT_CHANNELS = 'chat_channels';

export default {
	MYCASES,
	MYCASES_WIDGET,
	ALLCASES,
	CASES_HISTORY,
	WAITINGROOM,
	ACTIVITIES,
	ACTIVITIES_WIDGET,
	NOTIFICATIONS,
	NOTIFICATIONS_WIDGET,
	MEETING_SUMMARY_FILES,
	MEETING_SUMMARY_INVITEES,
	ANALYTIC_TICKETS_LOGS,
	TICKETS_REFERRALS,
  MANAGEMENT_USERS,
	CLIENTS_ORGANIZATION,
	SURVEYS,
  MANAGEMENT_ORGANIZATIONS,
  USER_TICKETS,
  ACTIVITY_ATTENDEES_TICKETS,
  USER_INVITATIONS,
  SCHEDULERS,
  CHAT_CHANNELS
};
